import { useState } from 'react';
import { Nav, Button, Dropdown } from 'react-bootstrap';
import { Info, MoreVertical, Trash2, CheckSquare, Move } from 'lucide-react';
// import Image from 'next/image';
import UploadPhotosModal from './UploadPhotosModal';

const photoTabs = ["Photos", "Albums"];

export default function PhotosSection() {
  const [activeTab, setActiveTab] = useState("Photos");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [selectedPhotos, setSelectedPhotos] = useState(new Set());

  const handlePhotoUpload = (newPhotos) => {
    setPhotos((prev) => [...newPhotos, ...prev]);
    setShowUploadModal(false);
  };

  const togglePhotoSelection = (photoId) => {
    const newSelected = new Set(selectedPhotos);
    if (newSelected.has(photoId)) {
      newSelected.delete(photoId);
    } else {
      newSelected.add(photoId);
    }
    setSelectedPhotos(newSelected);
  };

  const handleDeleteSelected = () => {
    setPhotos((prev) => prev.filter((photo) => !selectedPhotos.has(photo.id)));
    setSelectedPhotos(new Set());
  };

  const handleSelectAll = () => {
    if (selectedPhotos.size === photos.length) {
      setSelectedPhotos(new Set());
    } else {
      setSelectedPhotos(new Set(photos.map((p) => p.id)));
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="h4 mb-0">Photos</h2>
          <div className="d-flex gap-2">
            {selectedPhotos.size > 0 && (
              <>
                <Button variant="outline-danger" onClick={handleDeleteSelected}>
                  <Trash2 size={18} />
                </Button>
                <Button variant="outline-primary" onClick={handleSelectAll}>
                  <CheckSquare size={18} />
                </Button>
              </>
            )}
            <Button variant="primary" onClick={() => setShowUploadModal(true)}>
              Add Photos
            </Button>
          </div>
        </div>

        <Nav className="border-bottom gap-4 mx-n3 px-3 mb-4">
          {photoTabs.map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-1 border-bottom border-3 ${
                  activeTab === tab
                    ? "border-primary text-primary"
                    : "border-transparent text-muted"
                }`}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {photos.length === 0 ? (
          <div className="d-flex align-items-center gap-2 text-muted">
            <div
              className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
              style={{ width: "32px", height: "32px" }}
            >
              <Info size={16} className="text-white" />
            </div>
            <span>Sorry, no photos were found.</span>
          </div>
        ) : (
          <div className="row g-3">
            {photos.map((photo) => (
              <div key={photo.id} className="col-md-4 col-lg-3">
                <div
                  className="position-relative"
                  style={{ paddingBottom: "100%" }}
                >
                  <div className="position-absolute top-0 start-0 w-100 h-100">
                    {/* <Image src={photo.url} alt="" className="rounded object-fit-cover" fill /> */}
                    <img
                      src={photo.url}
                      alt=""
                      className="img-fluid rounded"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    />

                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-10 rounded">
                      {/* Selection Overlay */}
                      <div className="p-2">
                        <Button
                          variant={
                            selectedPhotos.has(photo.id) ? "primary" : "light"
                          }
                          size="sm"
                          className="rounded-1"
                          onClick={() => togglePhotoSelection(photo.id)}
                        >
                          Select
                        </Button>
                      </div>

                      {/* Actions Menu */}
                      <Dropdown className="position-absolute top-0 end-0 m-2">
                        <Dropdown.Toggle
                          variant="light"
                          size="sm"
                          className="rounded-circle p-1"
                        >
                          <MoreVertical size={16} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item className="d-flex align-items-center gap-2">
                            <Move size={16} />
                            Move
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="d-flex align-items-center gap-2 text-danger"
                            onClick={() => {
                              setPhotos((prev) =>
                                prev.filter((p) => p.id !== photo.id)
                              );
                              setSelectedPhotos((prev) => {
                                const next = new Set(prev);
                                next.delete(photo.id);
                                return next;
                              });
                            }}
                          >
                            <Trash2 size={16} />
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <UploadPhotosModal
          show={showUploadModal}
          onHide={() => setShowUploadModal(false)}
          onUpload={handlePhotoUpload}
        />
      </div>
    </div>
  );
}
